<template>
    <div class="progress-bar-header">
        <div class="container">
            <a href="#" class="progress-back" @click="goBack" v-if="showBackButton">
                <span class="material-symbols-rounded">west</span>
                <span class="progress-back-text">{{ __('Back') }}</span></a>
            <span class="progress-num">{{ questionNumber }} / <strong>{{ numberOfTabs }}</strong></span>
        </div>  
        
        <div class="progress-bar">
            <ul class="no-list-style">
                <li :class="{'active': index <= questionNumber}" v-for="index in numberOfTabs" :key="index"></li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            questionNumber: {
                type: Number,
                required: true,
                default: 1
            },
            numberOfTabs: {
                type: Number,
                required: true,
                default: 1
            },
            showBackButton: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        methods: {
            goBack() {
                this.$emit('goBack')
            }
        }
    }
</script>